import React, { useEffect } from 'react';
import { color } from '~/assets/styles/colors';

function AutoTabInputs(props) {
	const { values, setValues, errorMessage, setErrorMessage } = props;

	const handleChange = (e, nextInput, prevInput) => {
		setErrorMessage("");
		const { name, value } = e.target;

		setValues((prevValues) => ({
			...prevValues,
			[name]: value,
		}));

		if (value && nextInput) {
			nextInput.focus();
		} else if (!value && prevInput) {
			prevInput.focus();
		}
	};

	useEffect(() =>{
		console.log(errorMessage, setErrorMessage)
	}, [
		errorMessage
	])

	return (
		<div>
			<input
				type="text"
				name="input1"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input1}
				onChange={(e) => handleChange(e, document.querySelector('input[name="input2"]'), null)}
				maxLength="1"
			/>
			<input
				type="text"
				name="input2"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input2}
				onChange={(e) => handleChange(e, document.querySelector('input[name="input3"]'), document.querySelector('input[name="input1"]'))}
				maxLength="1"
			/>
			<input
				type="text"
				name="input3"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input3}
				onChange={(e) => handleChange(e, document.querySelector('input[name="input4"]'), document.querySelector('input[name="input2"]'))}
				maxLength="1"
			/>
			<input
				type="text"
				name="input4"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input4}
				onChange={(e) => handleChange(e, document.querySelector('input[name="input5"]'), document.querySelector('input[name="input3"]'))}
				maxLength="1"
			/>
			<input
				type="text"
				name="input5"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input5}
				onChange={(e) => handleChange(e, document.querySelector('input[name="input6"]'), document.querySelector('input[name="input4"]'))}
				maxLength="1"
			/>
			<input
				type="text"
				name="input6"
				className="input-token-code"
				style={{
					borderColor: errorMessage ? 'red' : '#CDCDCD',
					color: errorMessage ? 'red' : color.secondary,
					fontWeight: 'bold',
				}}
				placeholder="0"
				value={values.input6}
				onChange={(e) => handleChange(e, null, document.querySelector('input[name="input5"]'))}
				maxLength="1"
			/>
		</div>
	);
};

export default AutoTabInputs;
